import { useParams, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { EntityPageHeader } from '@/shared/components'
import { PeriodeForm } from '../components'
import { usePeriode, useCreatePeriode, useUpdatePeriode } from '../hooks/use-periodes'
import type { PeriodType } from '@/shared/types/common'

export function PeriodeFormPage() {
  const { id } = useParams<{ id: string }>()
  const navigate = useNavigate()
  const { t } = useTranslation()
  const isEdit = !!id

  const { data: periode, isLoading } = usePeriode(id ? parseInt(id) : undefined)
  const createPeriode = useCreatePeriode()
  const updatePeriode = useUpdatePeriode()

  const handleSubmit = (data: {
    titre: string
    typePeriode?: PeriodType
    actif: boolean
    datesPeriodes: Array<{ id?: number; libelle: string; dateDebut: string; dateFin: string }>
  }) => {
    if (isEdit) {
      updatePeriode.mutate(
        { id: parseInt(id!), data: { ...data, id: parseInt(id!) } },
        { onSuccess: () => navigate('/administration/periodes') },
      )
    } else {
      createPeriode.mutate(data, {
        onSuccess: () => navigate('/administration/periodes'),
      })
    }
  }

  if (isEdit && isLoading) {
    return (
      <div className="flex justify-center py-12">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    )
  }

  return (
    <div>
      <EntityPageHeader
        title={
          isEdit
            ? t('administration.sections.periods.editTitle', 'Modifier la période')
            : t('administration.sections.periods.createTitle', 'Créer une période')
        }
        backTo="/administration/periodes"
      />
      <PeriodeForm
        periode={periode}
        onSubmit={handleSubmit}
        isPending={createPeriode.isPending || updatePeriode.isPending}
      />
    </div>
  )
}
